var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.optionsInSelectedLanguage,"return-object":"","item-value":"id","item-text":"translation"},model:{value:(_vm.choiceInSelectedLanguage),callback:function ($$v) {_vm.choiceInSelectedLanguage=$$v},expression:"choiceInSelectedLanguage"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }